var map = {
	"./css.png": 379,
	"./html.png": 80,
	"./java.png": 57,
	"./jquery.png": 421,
	"./js.png": 803,
	"./jsp.png": 684,
	"./mysql.png": 640,
	"./php.png": 493,
	"./react.png": 396,
	"./scss.png": 354,
	"./spring.png": 572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 680;